import axios from '../../axios/index.js'

export default {
  updatePassword(data) {
    return axios.post('user/updatePassword', data)
  },
  forgotPassword (data) {
    return axios.post('user/forgotPassword', data)
  },
  resetPassword (data) {
    return axios.post('user/resetPassword', data)
  }

}
